export default __webpack_public_path__ + "static/keyboard-607b210dcf44ee956897dc3cf9eb284a.svg";